import { z } from "zod";
import { LinkedButtonWhenEnumSchema } from "../Enums/LinkedButtonWhenEnum";

export const LinkedButtonDtoSchema = z.object({
    linkedButtonKey: z.string(),
    linkedButtonWhen: LinkedButtonWhenEnumSchema.nullish(),
});

export type LinkedButtonDto = z.infer<typeof LinkedButtonDtoSchema>;